import {createSlice} from "@reduxjs/toolkit";
import {setUIActivityPeriodSearchFilter} from "./actions";
import {ActivityPeriodSearchCriteria} from "@ots-frontend/ots-data";

type ActivityPeriodUIState = {
  searchFilter?: ActivityPeriodSearchCriteria
}

const INITIAL_STATE: Readonly<ActivityPeriodUIState> = {};

const activityPeriodUISlice = createSlice({
  name: "ots-ui/activity-period",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIActivityPeriodSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const activityPeriodUIReducer = activityPeriodUISlice.reducer;
